import { render, staticRenderFns } from "./InspectDetail.vue?vue&type=template&id=00e81439"
import script from "./InspectDetail.vue?vue&type=script&lang=js"
export * from "./InspectDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports